<template>
  <div
    ref="root"
    class="tabs"
    :class="bem('tabs', { appearance, underline, underlineContainment })"
  >
    <div class="tabs__tabs">
      <div
        v-for="tab in tabs"
        :key="tab.href || tab.name"
        ref="tabs"
        class="tabs__tab"
      >
        <TabItem
          :tab="tab"
          :active="tab.name ? activeTabName === tab.name : tab.active"
          :appearance="appearance"
          :data-active-tab="tab.name ? activeTabName === tab.name : tab.active"
          @click="$emit('update:activeTabName', tab.name)"
        />
      </div>
      <div v-if="$slots.aside" class="tabs__aside">
        <slot name="aside" />
      </div>
    </div>
  </div>
</template>

<script>
  import { bem } from 'src/utils/bem.js';

  import TabItem from 'src/components/tabs/TabItem/TabItem.vue';

  export default {
    name: 'BasicTabs',
    components: { TabItem },
    model: {
      prop: 'activeTabName',
      event: 'update:activeTabName',
    },
    props: {
      tabs: {
        type: Array,
        required: true,
      },
      activeTabName: [String, Number],
      appearance: String,
      underline: [Boolean, String],
      underlineContainment: String,
    },
    mounted() {
      // ставим вызов в очередь чтобы попасть с вью в один и тот же рендер цикл и избежать двойного forced reflow
      requestAnimationFrame(() => {
        const { root, tabs } = this.$refs;
        const active = tabs.find(el => el.children[0].dataset.activeTab);
        root.scrollLeft = active.offsetLeft - root.offsetLeft;
      });
    },
    methods: {
      bem,
    },
  }
</script>